
export default {
  name: 'XppenCsae',
  layout: 'default',
  head() {
    return {
      title: 'XPPen Space — Child Sexual Abuse and Exploitation (CSAE) Standards',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Published CSAE and CSAM prevention standards for the XPPen Space app by Hanvon Ugee (HK) Technology Co., Ltd. (XPPen).',
        },
      ],
    }
  },
  mounted() {
    if (!process.client) return
    try {
      const header = document.querySelector('header')
      const footer = document.querySelector('footer')
      if (header) header.style.display = 'none'
      if (footer) footer.style.display = 'none'
    } catch (e) {}
  },
}
